
const baseURL = 'https://flixia.herokuapp.com';

export default baseURL;


// WEBPACK FOOTER //
// ./src/Pages/components/api.js